import React, { Component } from 'react';
import { connect } from 'shalala';
import { Spinner, Col, Row } from 'react-bootstrap';

import { useStore } from '../../store';
import Loading from '../../facturotopia/loading/Loading';
import PageHeader from '../../support/page-header/PageHeader';
import TimbradoSftpStatusBadge from './list/components/TimbradoSftpStatusBadge';

class TimbradoSftpInfo extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { data = {} } = props.location.state || {};
    const { id } = this.props.match.params;

    this.state = {
      data: !!data.id ? { ...data } : { id },
    };

    props.setData(this.state.data);
  }

  componentDidMount() {
    const { data } = this.state;

    if (!!data.filename) {
      return;
    }

    this.props.get(data.id);
  }

  render() {
    const { data = {}, busy } = this.props;

    if (!!busy) {
      return <Loading className="text-info" />;
    }

    return (
      <>
        <PageHeader
          to="/modulos/timbrado-sftp"
          text="Tickets"
        />

        <h5>
          <Row>
            <Col>
              {!!busy && (
                <Spinner
                  animation="border"
                  role="status"
                  size="sm"
                  className="mr-3"
                >
                  <span className="sr-only">Loading socio info...</span>
                </Spinner>
              )}
              {data.id || '...'}
            </Col>
          </Row>
        </h5>

        {!!data.filename && (
          <div>
            <div className="pb-2">
              <strong>Creación: </strong> {data.created_at}
              <br />
              <strong>Actualización: </strong> {data.created_at}
              <br />
              <strong>Archivo: </strong> {data.filename}
              <br />
              <strong>Folio fiscal: </strong> {data.cfdi_uuid}
              <br />
              <strong>Status: </strong> <TimbradoSftpStatusBadge data={data} />
              <br />
              <strong>Mensaje: </strong> {data.razon_status}
              <br />
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapState = (state) => {
  return state.modulo.timbrado_sftp.info;
};

const mapActions = (actions) => {
  return actions.modulo.timbrado_sftp.info;
};

export default connect(useStore, mapState, mapActions)(TimbradoSftpInfo);
